<tt-grid *ngIf="!!grid" [(ttOptions)]="grid" (ttRowDataChange)="submitted = false"></tt-grid>
